import { Star } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      quote:
        "Chef Paul and Holly made our wedding day absolutely magical. The food was incredible, and every guest is still talking about the braised short ribs. They treated us like family from the first consultation to the last dance.",
      author: "Sarah & Michael Thompson",
      event: "Wedding Reception",
      rating: 5,
    },
    {
      quote:
        "We hosted our company's annual gala at The Pardue Center, and Gracious Gatherings exceeded every expectation. The presentation was stunning, the service impeccable, and the food was the best we've ever had at a corporate event.",
      author: "Jennifer Martinez",
      event: "Corporate Gala",
      rating: 5,
    },
    {
      quote:
        "My daughter's quinceañera was everything we dreamed of and more. Holly helped us design every detail, and the Latin-inspired menu was authentic and delicious. Our family still raves about it!",
      author: "Iola Perla",
      event: "Quinceañera",
      rating: 5,
    },
    {
      quote:
        "As a nonprofit, we were worried about budget, but Chef Paul worked with us to create an amazing holiday luncheon that didn't break the bank. The quality was outstanding, and the discounted pricing made it possible.",
      author: "David Chen",
      event: "Nonprofit Fundraiser",
      rating: 5,
    },
  ];

  return (
    <section id="testimonials" className="section-padding bg-muted/30">
      <div className="container-elegant">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-accent font-medium tracking-widest uppercase text-sm mb-3">
            Client Love
          </p>
          <h2 className="heading-section text-foreground mb-4">
            What Our Guests Say
          </h2>
          <div className="flex justify-center mb-6">
            <span className="text-accent text-3xl">⚜</span>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="card-elevated p-8 hover:shadow-lg transition-shadow duration-300"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 fill-accent text-accent"
                  />
                ))}
              </div>

              {/* Quote */}
              <p className="text-muted-foreground italic leading-relaxed mb-6">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="border-t border-border/50 pt-4">
                <p className="font-semibold text-foreground">
                  {testimonial.author}
                </p>
                <p className="text-accent text-sm">{testimonial.event}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
